import { connect } from 'react-redux'
import { getInvestments } from 'services/user'
import Navigation from 'support/navigation'
import View from './View'
import { getIdeaTemplatelist, getScorecardTemplatelist } from 'services/innovate/templates'
import { getInnovateChallengeActiveTypes ,getInnovateChallenge} from 'services/innovate/challenge'
import { getGroups } from 'services/challenge_steps'

const mapStateToProps = state => {
  return {
    ideas: state.data.user.investments.ideas,
    userEmail: state.data.user.userEmail,
    listScorecardTemplate:state.data.templates.listScorecardTemplate,
    listIdeaTemplate:state.data.templates.listIdeaTemplate,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getScorecardTemplatelistFn: ()=>{
      dispatch(getScorecardTemplatelist())
    },
    getInnovateChallengeFn: (challengeKeyId)=>{
      dispatch(getInnovateChallenge(challengeKeyId))
    },
    getCommunitesAsGroup : ()=> dispatch(getGroups()),
    getIdeaTemplatelistFn: ()=>{
      dispatch(getIdeaTemplatelist())
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
    // getInvestments: userEmail => {
    //   dispatch(getInvestments(userEmail))
    // },
    // onTitleClick: id => {
    //   dispatch(Navigation.navigateToIdea(id))
    // },
    // navigateHome: () => dispatch(Navigation.navigateToExplore()),
    navigateToProfile: () => dispatch(Navigation.navigateToProfile())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
